<div class="p-3">
  <div class="modal-header">
    <p class="modal-title">
      <strong>{{ isEditMode ? "Update Document CM9 Mapping" : "Create Document CM9 Mapping" }}</strong>
    </p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
  </div>

  <div class="modal-body p-3">
    <form [formGroup]="createForm" class="d-flex flex-column row">

      <div class="row m-0 pt-2">
        <div class="col-6">
          <label>Document Type</label>
          <ng-select
            [items]="documentTypes"
            [closeOnSelect]="true"
            [multiple]="false"
            bindLabel="documentTypeName"
            bindValue="id"
            formControlName="documentTypeId">
          </ng-select>
        </div>
        <div class="col-6">
            <label>Document Value</label>
            <ng-select
                [items]="documentValues"
                [closeOnSelect]="true"
                [multiple]="false"
                bindLabel="displayText"
                bindValue="id"
                formControlName="documentValueId"
                (change)="onDocumentValueChange($event)">
            </ng-select>
        </div>
      </div>

      <div class="row m-0 pt-2">
        <div class="col-6">
            <label>Document Name (Value) - CM9</label>
            <ng-select
                [items]="documentNamesFiltered"
                [closeOnSelect]="true"
                [multiple]="false"
                bindLabel="displayText"
                bindValue="id"
                formControlName="documentNameId">
            </ng-select>
        </div>
        <div class="col-6 d-flex align-items-center gap-4 pt-3">
          <div class="d-flex align-items-center gap-2">
            <input type="checkbox" formControlName="isActive" id="isActiveCheck" />
            <label for="isActiveCheck" class="mb-0">Active</label>
          </div>
          <div class="d-flex align-items-center gap-2">
            <input type="checkbox" formControlName="isMandatory" id="isMandatoryCheck" />
            <label for="isMandatoryCheck" class="mb-0">Mandatory</label>
          </div>
        </div>
      </div>
      <div class="row m-0 pt-2">
        <div class="col-12">
          <label for="instructionField">Instruction</label>
          <textarea
            id="instructionField"
            class="form-control"
            formControlName="instruction"
            rows="3"
            maxlength="250">
          </textarea>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="modal.dismiss()">Cancel</button>
    <button
      class="btn btn-secondary"
      [disabled]="createForm.invalid || (isEditMode && !hasChanges)"
      eosDebounce
      (debounceClick)="saveActivity()">
      {{ isEditMode ? "Update" : "Create" }}
    </button>
  </div>
</div>